<template>
    <v-container fluid>
        <v-btn
            :loading="companiesWithInfo === null"
            @click="newCompany"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Companies ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="companiesWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="companyWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="companyWithInfo in companiesWithInfo"
                >
                    <!--@click="loadCompanyForm(companyWithInfo.entity)"-->
                    <v-card
                    @click="loadCompanyForm(companyWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{companyWithInfo.entity.name}}</h5>
                        </v-card-title>
                        <v-card-text>

                                        <v-row justify="start">
                <v-col
                cols="4"
                >
                        <v-btn
                            :disabled="!(companyWithInfo.entity.activeCustomerCount>0)"
                            @click.stop="getLogReport(companyWithInfo.entity.id, 1)"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >Get Report: Active</v-btn>
                </v-col>
                <v-col
                cols="4"
                >
                                                <v-btn
                            :disabled="!(companyWithInfo.entity.terminatedCustomerCount>0)"
                            @click.stop="getLogReport(companyWithInfo.entity.id, 0)"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >Get Report: CorpTerminated</v-btn>
                </v-col>
                <v-col
                cols="4"
                >
                                                <v-btn
                            :disabled="!(companyWithInfo.entity.suspendedCustomerCount>0)"
                            @click.stop="getLogReport(companyWithInfo.entity.id, 3)"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >Get Report: CorpSuspended</v-btn>
                </v-col>
                            </v-row>


            <v-row justify="start">
                <v-col
                cols="4"
                >
                        <v-btn
                            :disabled="!(companyWithInfo.entity.activeCustomerCount>0)"
                            @click.stop="$router.push({
                            name: 'Customers',
                            params: {
                                companyId: companyWithInfo.entity.id,
                                status: 1
                            },
                        })"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >Active: {{companyWithInfo.entity.activeCustomerCount}}</v-btn>
                </v-col>
                <v-col
                cols="4"
                >
                                                <v-btn
                            :disabled="!(companyWithInfo.entity.terminatedCustomerCount>0)"
                            @click.stop="$router.push({
                            name: 'Customers',
                            params: {
                                companyId: companyWithInfo.entity.id,
                                status: 0
                            },
                        })"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >CorpTerminated: {{companyWithInfo.entity.terminatedCustomerCount}}</v-btn>
                </v-col>
                <v-col
                cols="4"
                >
                                                <v-btn
                            :disabled="!(companyWithInfo.entity.suspendedCustomerCount>0)"
                            @click.stop="$router.push({
                            name: 'Customers',
                            params: {
                                companyId: companyWithInfo.entity.id,
                                status: 3
                            },
                        })"
                            class="text-none ma-3"
                            color="secondary darken-1"
                        >CorpSuspended: {{companyWithInfo.entity.suspendedCustomerCount}}</v-btn>
                </v-col>
                            </v-row>
            
            
            

        
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        <v-snackbar
            :color="notifyColor"
            :timeout="5000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        </v-container>

                <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="companyFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeCompanyForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Company Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
            <CompanyForm
                :key="companyFormKey"
                :company-in="companyFormCompany"
                @close="closeCompanyForm"
                @deleted="deleteCompany"
                @saved="updateCompany"
            />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Company from "../models/Company.model";
import uuid4 from "../helpers/uuid4";
import Company from "../models/Company.model";
import CompanyForm from "../components/forms/CompanyForm"

export default {
    name: "Companies",
    props: ["status"],
    data: function() {
        return {
            //main data
            companiesWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            companyFormVisible: false,
            companyFormKey: 0,
            companyFormCompany: new Company(),

            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,

            isLoading: false,
            isGenerating: false,

        };
    },
    mounted: function() {
        this.getCompanies();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        CompanyForm
        //
    },
    methods: {
        getLogReport(companyId, status) {
                this.isLoading = true;
                this.isGenerating = true;
                this.$store
                    .dispatch("customers/customerlogreport", {
                        companyId: companyId,
                        status: status,
                    })
                    .then(
                        (fileId) => {
                            this.notify("Downloading...", "success");

                            this.$store.dispatch("files/get", {
                                fileId: fileId,
                                namePrefix:
                                    "CustomerLogReport",
                            });
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.getLogReportDone);
        },
        getLogReportDone() {
            this.isLoading = false;
            this.isGenerating = false;
        },

        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },


        getCompanies() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("companies/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(companiesResponse => {
                    if (this.requestId == companiesResponse.requestId) {
                        this.companiesWithInfo = companiesResponse.data.page;
                        this.totalMatches = companiesResponse.data.total;
                        this.pageSize = companiesResponse.data.pageSize;
                        this.pageNo = companiesResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            companiesResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.companiesWithInfo !== null) this.companiesWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getCompanies,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newCompany() {
            var company = new Company();
            company.id = 0;
            this.loadCompanyForm(company);
        },
        loadCompanyForm(company) {
            this.companyFormCompany = new Company().set(company);
            this.companyFormKey = company.id;
            this.companyFormVisible = true;
        },
        closeCompanyForm() {
            this.companyFormVisible = false;
            this.companyFormCompany = new Company();
            this.companyFormKey = null;
        },
        updateCompany() {
            this.paginationDebounce(0);
        },
        deleteCompany() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
